import { Button, Image, Text } from '@mantine/core';
import "../styles/GameButton.css"
import icons from "../assets/icons.json"
import supabase from '../api/client';

export const GameButton = ({ setQuery, setFilters, game, pos }) => {

  const convertDate = (dateString) => {
    var date = new Date(dateString)
    var monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ]

    var edtOptions = {
      timeZone: "America/New_York",
      hour12: true,
      hour: "numeric",
      minute: "2-digit"
    }

    var edtTime = date.toLocaleTimeString("en-US", edtOptions)
    var monthIndex = date.getMonth()
    var day = date.getDate();
    var year = date.getFullYear()
    var monthName = monthNames[monthIndex]
    var formattedDate = monthName + " " + day + ", " + year + " : " + edtTime + " EDT"
    return formattedDate
  }

  const getBorder = (pos) => {
    if (pos === "left")
      return {borderRight: "1px solid #404040"}
    if (pos === "right")
      return {borderLeft: "1px solid #404040"}

    return {borderLeft: "1px solid #404040", borderRight: "1px solid #404040"}
  }

  const updateQuery = () => {
    let query = supabase.from("Highlight").select("id, title, videoId").eq("gameId", game.id).order("created_at", { ascending: false })

    setFilters({
      "event": {...game.Event, value: (game.Event.id).toString(), label: game.Event.name},
      "game": {...game, value: (game.id).toString(), label: game.name},
      "team": null,
      "player": null
    })

    setQuery(query)
  }

  return (
    <>
      <Button
        className='game-button'
        onClick={updateQuery}
        h={"100%"}
        color="#191919"
        styles={{
          root: {
            borderRadius: 0,
            padding: 0,
            borderTop: "1px solid #404040",
            borderBottom: "1px solid #404040",
            ...getBorder(pos),
            transform: "none"
          },
          label: {
            width: "100%",
            display: "inline",
          }
        }}
      >
        <Text styles={{
          root: {
            whiteSpace: "pre-wrap",
            paddingTop: "2%",
            verticalAlign: "center",
            color: "white",
            fontWeight: "bold"
          }
        }}
        >
          {convertDate(game.date)}
        </Text>
        <Text styles={{
          root: {
            whiteSpace: "pre-wrap",
            verticalAlign: "center",
            borderBottom: "1px solid #404040",
            paddingBottom: "2%",
            color: "white",
            fontWeight: "bold"
          }
        }}
        >
          {game["clip-count"] + ` ${game["clip-count"] === 1 ? "clip" : "clips"}`}
        </Text>
        <div style={{ alignContent: "center" }}>
          <div className="game-container">
            <div className="left-container">
              <Image src={icons[game.teamOne.id].link} w={35} h={35} />
              <span>VS</span>
              <Image src={icons[game.teamTwo.id].link} w={35} h={35} />
            </div>
            <div className="right-container">
              <div className="team1">{icons[game.teamOne.id].name}</div>
              <div className="team2">{icons[game.teamTwo.id].name}</div>
            </div>
          </div>
        </div>
      </Button>
    </>
  )
}
